module.exports = __webpack_public_path__ + "img/photoboot-classico.b8a43c39.jpg";